import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import { Card, Col, Row } from "react-bootstrap";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { getFileLiveUrl } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import { _LIST_CONTENTS } from "../../models/fieldSettings";

const TestimonialsList = (props) => {
  const [windowSize, setWindowSize] = useState(null);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    setWindowSize(window.innerWidth);
    loadData();
  }, []);

  const loadData = () => {
    _LIST_CONTENTS({
      type: "testimonial",
      limit: 20,
      order_by: "row_order ASC",
    }).then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
      }
    });
  };

  useEffect(() => {
    const handleResize = () => {
      // Perform actions on window resize
      //setWindowSize([window.innerWidth, window.innerHeight]);
      setWindowSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow:
      windowSize && windowSize < 500
        ? 1
        : dataList.length > 2
        ? 3
        : dataList.length,
    slidesToScroll:
      windowSize && windowSize < 500
        ? 1
        : dataList.length > 2
        ? 3
        : dataList.length,
    autoplay: true,
  };

  const getCard = (item) => {
    return (
      <div>
        <div className="testimonial-wrapper">
          <Card className="m-3 border-0 testimonial">
            <Card.Body>
              <Row className="border-0">
                <Col md={12}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="testimonial-rate bg-white mb-0">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>

                    <div className="ms-3">
                      <img
                        src="https://anjac.edu.in/files_list/anjac/fm/quote.png"
                        style={{
                          maxWidth: "70px",
                          opacity: "0.5",
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md={12} className="mt-3">
                  <div
                    style={{
                      height: "50px",
                      overflowY: "auto",
                      fontSize: "15px",
                    }}
                  >
                    {item.content_html}
                  </div>
                </Col>
              </Row>
            </Card.Body>
            <div className="testimonial-triangle"></div>
          </Card>
          <div className="testimonial-footer ms-5">
            <Row className="mt-3">
              <Col md={3} className="mt-2">
                <div className="testimonial-author-img">
                  <img
                    src={getFileLiveUrl(item.feature_image)}
                    className="testimonial-logo"
                  />
                </div>
              </Col>
              <Col md={9} className="mt-2">
                <div>
                  <div className="testimonial-author-info">
                    <h4 className="college-name">{item.title}</h4>
                    <p className="location-name mt-2 ms-5 text-start">
                      {item.category}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <section className="py-4">
        <div className="container">
          <h3 className="text-center pb-4">Testimonials</h3>
          <Slider {...settings}>
            {dataList.map((item, i) => getCard(item, i))}
          </Slider>
        </div>
      </section>
    </>
  );
};

export default TestimonialsList;
